import React from 'react';
import { SwiperSlide } from 'swiper/react';

import {
    Carousel,
    CarouselArrowNavigation,
    CarouselWrapper
} from '$partials/base/carousel';

import { Button } from '$partials/ui';
import { EventListingItem } from '$partials/items';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').EventCarouselBlock}
 */
const EventCarousel = ({
    ctaLink,
    events,
    text,
    title
}) => {
    return (
        <section className='col-wrapper-breakout bg-surface-panel-yellow rounded-lg pt-24 pb-8 md:pb-24 flex flex-wrap'>
            <div className='w-full col-padding'>
                <h2 className='type-style-sans-h1 w-full md:w-7/12'>
                    {title}
                </h2>

                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                        {text}
                    </p>
                )}
            </div>

            <Carousel
                swiperConfig={{
                    a11y: { enabled: true },
                    slidesPerView: 1.2,
                    slidesOffsetBefore: 8,
                    slidesOffsetAfter: 8,
                    breakpoints: {
                        992: {
                            slidesPerView: 2.35,
                        },
                        1440: {
                            slidesPerView: 2.5,
                            slidesOffsetBefore: 16,
                            slidesOffsetAfter: 16
                        }
                    },
                    spaceBetween: 8,
                    grabCursor: false,
                }}>
                <div className='w-full col-padding flex justify-end mb-16 mt-20 md:mt-12'>
                    <div className='flex'>
                        {ctaLink?.linkTo && (
                            <Button
                                as='a'
                                className='button-outcome'
                                href={formatLinkBlockToUrl(ctaLink)}>
                                {'View all'}
                            </Button>
                        )}

                        {events?.length > 2 && (
                            <div className='hidden sm:block ml-8 md:ml-16'>
                                <CarouselArrowNavigation />
                            </div>
                        )}
                    </div>
                </div>

                <div className='-mx-4 md:-mx-8 mt-24 overflow-hidden'>
                    <CarouselWrapper>
                        {events?.map(item => {
                            if (!item?.event) { return null; }

                            return (
                                <SwiperSlide
                                    aria-roledescription='slide'
                                    className='select-none cursor-pointer flex flex-wrap mt-4'
                                    key={item?.event?.id}
                                    role='group'>
                                    <EventListingItem {...item?.event} />
                                </SwiperSlide>
                            );
                        }).filter(Boolean)}
                    </CarouselWrapper>
                </div>
            </Carousel>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default EventCarousel;
